module.exports = __webpack_public_path__ + "static/media/West_Hall.61dc6ca3.webp";